import { ThemeSchemaResponse } from '@api/api/theme-overview';
import { FollowThemeButton } from '@terminal/components/follow-theme-button/FollowThemeButton';
import { THEME_TAG_COLOR_CLASS_MAP } from '@terminal/modules/reflexivity-graph/kg-insight-constants';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { ThemeLogoIcon } from '../../../../views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';
import styles from './ThemeHeader.module.scss';

interface ThemeHeaderProps {
  theme: ThemeSchemaResponse;
  isCondensed?: boolean;
}

export const ThemeHeader = ({
  theme,
  isCondensed = false,
}: ThemeHeaderProps) => {
  const { t } = useTranslation(['widget']);

  const { id, name, logo_url: logoUrl, type } = theme;

  const isMSTheme = theme?.metadata?.ms_basket_ticker;

  return (
    <div className={styles.flexRow}>
      <div
        className={clsx(styles.logoAndTitle, {
          [styles.condensed]: isCondensed,
        })}
      >
        <ThemeLogoIcon logo_url={logoUrl} name={name} key={id} type={type} />
        <div className={styles.flexColumn}>
          <span
            className={clsx(styles.themeType, THEME_TAG_COLOR_CLASS_MAP[type])}
          >
            {/* i18next-extract-mark-context-next-line ["industry", "macro", "financial"]  */}
            {!isMSTheme &&
              t('widget:themeOverview.type', {
                context: type,
              })}
          </span>
          <span
            className={clsx(styles.titleText, {
              [styles.condensed]: isCondensed,
            })}
          >
            {name}
          </span>
        </div>
      </div>
      <div className={styles.rightCluster}>
        <FollowThemeButton themeId={id} />
      </div>
    </div>
  );
};
